import { render, staticRenderFns } from "./SwitchAccountConfirmationView.vue?vue&type=template&id=20feef9b&scoped=true&"
import script from "./SwitchAccountConfirmationView.vue?vue&type=script&lang=js&"
export * from "./SwitchAccountConfirmationView.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAccountConfirmationView.vue?vue&type=style&index=0&id=20feef9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20feef9b",
  null
  
)

export default component.exports